// src/utils/supabase.js

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    'Missing Supabase environment variables. Please check your .env file:\n' +
    '- REACT_APP_SUPABASE_URL\n' +
    '- REACT_APP_SUPABASE_ANON_KEY'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Uses localStorage by default - session persists across browser restarts
  },
});

// Helper to get current user (synchronous, from cache)
export const getCurrentUser = () => {
  return supabase.auth.getUser();
};

// Helper to get current session
export const getSession = () => {
  return supabase.auth.getSession();
};

export default supabase;